<template>
<div class="info">
	<div class="title">投保信息</div>
	<Form :label-width="150" class="mt15">
	    <FormItem label="投保公司：" class="w600">
	        {{info.centerName}}
	    </FormItem>
		<div>
			<FormItem label="被保公司：">
				{{info.companyListString}}
			</FormItem>
		</div>
	    <FormItem label="联系电话：" class="w600">
	        {{info.phone}}
	    </FormItem>
	</Form>
</div>
</template>
<script>
export default {
	components:{},
	props:{
		info:Object
	},
	computed:{
	},
	methods:{
	}
}
</script>
<style lang="less" scoped>
	.img{
		display:flex;
		flex-wrap:wrap;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/common/applicantInfo.vue